export function setDescription(desc) {
  const el = document.querySelector("meta[name='description']");
  el.setAttribute('content', desc);
}

export function setTitle(title) {
  const el = document.querySelector('title');
  el.innerText = `${title}`;
}
